import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/images/MY-HMS-min.png"

const Mhms = () => {
  return (
    <>
     <div className="home-container">
      <Sidebar/>
      <div className="home-content">
        <img
             src={image} // Replace with your image URL
          alt="Clients"
          className="home-image"
        />
      </div>
    </div>
    </>
  )
}

export default Mhms